var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSecretaryN(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34935",
    "data-name": "Rectangle 34935",
    width: 82.325,
    height: 130.584,
    fill: "#1d1b4b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61087",
    "data-name": "Group 61087",
    transform: "translate(-6897 -1421)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34933",
    "data-name": "Rectangle 34933",
    width: 160,
    height: 160,
    transform: "translate(6897 1421)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61086",
    "data-name": "Group 61086",
    transform: "translate(6936 1436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61085",
    "data-name": "Group 61085",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117587",
    "data-name": "Path 117587",
    d: "M82.322,125.5c-.18-8.95.03-17.92-.08-26.88a26.7,26.7,0,0,0-15.515-24.1,42.854,42.854,0,0,0-14.066-3.777,107.5,107.5,0,0,0-18.1.033c-5.95.373-12.749.612-18.2,3.3A28.523,28.523,0,0,0,5.118,83.949,25.333,25.333,0,0,0,1.512,92.7c-2.2,10.86-1.44,22.08-1.13,33.15.069,2.59.91,4.76,4.74,4.73q36.225-.3,72.45-.03c3.87.02,4.82-1.52,4.75-5.05m-27.87-50.02c-11.17,9.18-14.71,9.19-26.56,0Zm17.3,51.11c-12.66-.27-25.33-.1-38.49-.1-8.5,0-16.5.01-24.5-.01-1.6-.01-3.55.38-3.47-2.27.192-6.367-.192-12.864.027-19.28.206-6.019.521-12.946,4.037-18.047a34.693,34.693,0,0,1,8.536-8.1c1.53-1.11,3-.42,4.48.43,5.27,3.02,10.65,5.83,15.85,8.96,2.31,1.39,4.12,1.12,6.29-.16,4.95-2.91,10.15-5.4,14.95-8.51a5.56,5.56,0,0,1,7.13.32c3.3,2.615,6.534,5.664,8.495,9.452,1.85,3.572,2.238,7.774,2.222,11.738q-.034,8.123-.051,16.23c0,1.363,0,2.726-.013,4.089-.008,1.119.223,2.485-.314,3.48-1,1.85-3.358,1.816-5.179,1.781",
    fill: "#1d1b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117588",
    "data-name": "Path 117588",
    d: "M29.9,59.174a25.376,25.376,0,0,0,30.25-6.02c6.78-7.42,8.52-19.72,3.35-28.92-2.48-4.39-5.43-8.04-6.16-13.72-.89-7-7.31-9.39-14.34-10.34-9.58-1.3-18.26,4.82-18.69,14.36a5.684,5.684,0,0,1-2.19,4.62c-.89,1.25-1.58,2.17-2.16,3.17-7.63,13.15-4.59,29.36,9.94,36.85m26.57-35.81c.74.89,1.56,1.72,2.53,2.91,1.55,2.76,1.38,4.23-1.92,4.58a21.049,21.049,0,0,1-20.73-10.61c-1.39-2.46-.66-3.19,1.83-3.89,5.41-1.54,13.65,1.48,18.29,7.01M33.5,7.434a13.738,13.738,0,0,1,8.142-2.186c2.708.2,5.721.756,7.886,2.5a9.249,9.249,0,0,1,2.285,2.594,34.776,34.776,0,0,1,1.593,3.474c-1.377-.171-2.8-.754-4.161-1.063-1.386-.314-2.783-.576-4.191-.766a37.88,37.88,0,0,0-8.749-.18,13.091,13.091,0,0,0-3.977.866c-.926.4-2.124,1.187-2.7-.182-.95-2.29,2.11-4.01,3.87-5.06m-6.16,13.53c1.97-1.42,3.39-1.73,4.86,1.06,5.43,10.26,15.07,14.97,26.18,12.82,2.57-.5,2.71.44,2.92,2.4.39,3.71-1.04,6.76-3.01,10.1-8.09,11.86-24.36,12.52-33.55,1.24-5.81-7.13-4.69-22.32,2.6-27.62",
    fill: "#1d1b4b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecretaryN);
export default __webpack_public_path__ + "static/media/icon_secretary_n.affd670d2a1fcf70d93186ed89d824fa.svg";
export { ForwardRef as ReactComponent };